class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.open);

    if (this.mainDetailsToggle.open) this.closeOtherMenus();
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    if (!this.isConfigurableMegaMenu() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    window.clearTimeout(this.closeTimeout);
    this.open();
  }

  onMouseLeave() {
    if (!this.isConfigurableMegaMenu() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (this.contains(document.activeElement)) return;

    this.closeTimeout = window.setTimeout(() => this.close(), 180);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE' || !this.mainDetailsToggle.open) return;
    this.close();
    this.summary.focus();
  }

  isConfigurableMegaMenu() {
    return this.mainDetailsToggle.hasAttribute('data-mega-menu-details');
  }

  open() {
    this.closeOtherMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle?.open) menu.close();
    });
  }

  close() {
    window.clearTimeout(this.closeTimeout);
    super.close();
    if (this.header) {
      this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));
    }
  }
}

customElements.define('header-menu', HeaderMenu);

document.addEventListener('click', (event) => {
  if (event.target.closest('header-menu')) return;
  document.querySelectorAll('header-menu').forEach((menu) => menu.close());
});

if (window.Shopify?.designMode) {
  const getBlockSelector = (blockId) => `[data-mega-menu-block-id="${CSS.escape(blockId)}"]`;

  const closeMegaMenuBlock = (blockId) => {
    document.querySelectorAll(getBlockSelector(blockId)).forEach((element) => {
      const desktopMenu = element.closest('header-menu');
      if (desktopMenu) desktopMenu.close();

      const drawerDetails = element.closest('[data-mega-menu-drawer-details]');
      if (drawerDetails) {
        drawerDetails.removeAttribute('open');
        drawerDetails.classList.remove('menu-opening');
        drawerDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        drawerDetails.closest('.submenu-open')?.classList.remove('submenu-open');
      }
    });
  };

  document.addEventListener('shopify:block:select', (event) => {
    const blockId = event.detail?.blockId;
    if (!blockId || !document.querySelector(getBlockSelector(blockId))) return;

    if (window.matchMedia('(min-width: 990px)').matches) {
      const details = document.querySelector(`details[data-mega-menu-details]${getBlockSelector(blockId)}`);
      details?.closest('header-menu')?.open();
      return;
    }

    const drawer = document.querySelector('header-drawer');
    const drawerDetails = drawer?.querySelector(
      `details[data-mega-menu-drawer-details]${getBlockSelector(blockId)}`
    );
    if (!drawer || !drawerDetails) return;

    if (!drawer.mainDetailsToggle.open) drawer.mainDetailsToggle.querySelector('summary').click();
    window.setTimeout(() => {
      if (!drawerDetails.open) drawerDetails.querySelector('summary').click();
    }, 150);
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    if (event.detail?.blockId) closeMegaMenuBlock(event.detail.blockId);
  });
}
